var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from "@mui/material";
/**
 * Location page wrapper, displays a narrower content area.
 * @param id element id
 * @param children page content
 * @param rest: ContainerProps Props
 * @returns
 */
export const LocationPageWrapper = (_a) => {
    var { id, children } = _a, rest = __rest(_a, ["id", "children"]);
    return (_jsx(Container, Object.assign({ id: id, maxWidth: "md" }, rest, { children: children })));
};
